import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { Checkbox } from '../checkbox';
import { Label } from '../../label';
import { Tooltip } from '../../tooltip';
import { IconUiInfoFilled } from '../../icons/ui';
var CheckboxCard = function CheckboxCard(_ref) {
  var title = _ref.title,
    value = _ref.value,
    info = _ref.info,
    description1 = _ref.description1,
    description2 = _ref.description2,
    label = _ref.label,
    labelVariant = _ref.labelVariant,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, ["title", "value", "info", "description1", "description2", "label", "labelVariant", "variant"]);
  // Generates a unique ID for the checkbox element by replacing spaces with hyphens and converting to lowercase.
  var checkboxId = "checkbox-".concat(value.replace(/\s+/g, '-').toLowerCase());
  return jsx("label", {
    htmlFor: checkboxId,
    sx: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, CheckboxCardStyles.container), variant === 'list' ? CheckboxCardStyles.list : CheckboxCardStyles.card), props.checked && CheckboxCardStyles.containerChecked), props.disabled && CheckboxCardStyles.containerDisabled), props.reversed && CheckboxCardStyles.containerReversed),
    tabIndex: !props.disabled ? 0 : -1 // Make the div focusable only if not disabled
    ,
    "aria-label": title
  }, jsx("div", {
    sx: _objectSpread(_objectSpread({}, CheckboxCardStyles.checkbox), props.reversed && CheckboxCardStyles.checkboxReversed)
  }, jsx(Checkbox, _extends({}, props, {
    id: checkboxId,
    key: value,
    sx: CheckboxCardStyles.checkboxOverrideStyles
  })), jsx("span", {
    sx: CheckboxCardStyles.title
  }, title), info && jsx(Tooltip, {
    position: props.reversed ? 'left' : 'right',
    text: info
  }, jsx(IconUiInfoFilled, {
    size: "xsmall",
    fillColor: "var(--colors-grey-7)"
  }))), jsx("div", {
    sx: _objectSpread(_objectSpread({}, CheckboxCardStyles.content), props.reversed && CheckboxCardStyles.contentReversed)
  }, description1 && jsx("div", {
    sx: CheckboxCardStyles.descriptionEllipsis
  }, description1), description2 && jsx("div", {
    sx: CheckboxCardStyles.descriptionEllipsis
  }, description2)), label && jsx("div", {
    sx: _objectSpread(_objectSpread({}, CheckboxCardStyles.label), props.reversed && CheckboxCardStyles.labelReversed)
  }, jsx(Label, {
    variant: labelVariant
  }, label)));
};
CheckboxCard.defaultProps = {
  checked: false,
  disabled: false,
  variant: 'card'
};
var CheckboxCardStyles = {
  container: {
    padding: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    cursor: 'pointer'
  },
  containerChecked: {
    backgroundColor: 'grey.5'
  },
  containerDisabled: {
    cursor: 'not-allowed',
    backgroundColor: 'unset',
    '> :nth-child(1), > :nth-child(2)': {
      color: 'grey.7'
    }
  },
  containerReversed: {
    alignItems: 'flex-end',
    textAlign: 'right'
  },
  card: {
    border: '1px solid',
    borderColor: 'grey.6',
    borderRadius: 'var(--corners-pageframe)'
  },
  list: {
    borderBottom: '1px solid',
    borderColor: 'grey.6',
    '&:last-of-type': {
      borderBottom: 'none'
    }
  },
  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    maxWidth: '100%'
  },
  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 1,
    lineHeight: 1,
    fontWeight: 'regular'
  },
  checkboxReversed: {
    flexDirection: 'row-reverse'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    ml: 4,
    color: 'grey.8',
    fontSize: 0,
    fontWeight: 'regular',
    lineHeight: 0
  },
  descriptionEllipsis: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  contentReversed: {
    ml: 0,
    mr: 4,
    textAlign: 'right'
  },
  label: {
    flex: 0,
    ml: 4
  },
  labelReversed: {
    ml: 0,
    mr: 4
  },
  checkboxOverrideStyles: {
    flex: 0,
    mb: 0,
    '& span': {
      mr: 0,
      ml: 0
    }
  }
};
export { CheckboxCard };